export enum AccountBookingType {
  MARKET,
  RETAIL,
  INTERNAL,
  EXTERNAL,
  RISK_ROUTING,
}

export namespace AccountBookingType {
  let elements = [
    AccountBookingType.MARKET,
    AccountBookingType.RETAIL,
    AccountBookingType.INTERNAL,
    AccountBookingType.EXTERNAL,
    AccountBookingType.RISK_ROUTING,
  ];
  let alias = "com.bcdfx.model.AccountBookingType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
